export default __webpack_public_path__ + "static/media/pmmm.96ce130a.mp4";